import { Component, Type } from '@angular/core';
import { MatStepperModule } from '@angular/material/stepper';
import { FieldType, FormlyFieldConfig, FormlyFieldProps, FormlyModule } from '@ngx-formly/core';

export interface FormlyStepperFieldConfig extends FormlyFieldConfig<FormlyFieldProps> {
  type: 'stepper' | Type<StepperComponent>;
}

@Component({
  selector: 'vectronic-formly-stepper',
  imports: [MatStepperModule, FormlyModule],
  template: `
    <mat-stepper orientation="vertical" linear="false">
      @for (step of field.fieldGroup; track $index) {
        <mat-step>
          <ng-template matStepLabel>{{ step.props?.label }}</ng-template>
          <formly-field [field]="step"></formly-field>
        </mat-step>
      }
    </mat-stepper>
  `,
  styles: ``,
})
export class StepperComponent extends FieldType {
  isValid(field: FormlyFieldConfig): boolean {
    if (field.key) return Boolean(field.formControl?.valid);
    return field.fieldGroup ? field.fieldGroup.every((f) => this.isValid(f)) : true;
  }
}
